"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {}
  };
});

var CreateUserDialog = function CreateUserDialog(_ref) {
  var error = _ref.error,
      clearError = _ref.clearError,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      open = _ref.open,
      children = _ref.children,
      labels = _ref.labels;
  var classes = useStyles();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      email = _useState2[0],
      _setEmail = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      firstname = _useState4[0],
      setFirstname = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      lastname = _useState6[0],
      setLastname = _useState6[1];

  var setEmail = function setEmail(e) {
    _setEmail(e);

    clearError();
  };

  var isValidEmail = email.length > 5;
  var isValidFirstname = firstname.length > 1;
  var isValidLastname = lastname.length > 0;
  var isValid = isValidEmail && isValidFirstname && isValidLastname;
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    classes: {
      paper: classes.dialog
    },
    open: open
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, labels.title), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "firstname",
    id: "firstname",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: labels.firstName,
    error: firstname.length > 0 && !isValidFirstname,
    helperText: firstname.length > 0 && !isValidFirstname ? labels.nameInvalid : '',
    autoFocus: true,
    required: true,
    onChange: function onChange(e) {
      return setFirstname(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "lastname",
    id: "lastname",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: labels.lastName,
    error: lastname.length > 0 && !isValidLastname,
    helperText: lastname.length > 0 && !isValidLastname ? labels.nameInvalid : '',
    required: true,
    onChange: function onChange(e) {
      return setLastname(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.TextField, {
    name: "email",
    id: "email",
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: labels.email,
    error: error || email.length > 0 && !isValidEmail,
    helperText: error || (email.length > 0 && !isValidEmail ? labels.emailInvalid : ''),
    required: true,
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    }
  }), children), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: classes.button,
    variant: "flat",
    type: "submit",
    onClick: function onClick() {
      return onClose();
    }
  }, labels.cancel), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: classes.button,
    variant: "flat",
    color: "primary",
    type: "submit",
    disabled: !isValid,
    onClick: function onClick() {
      return onSubmit({
        firstname: firstname,
        lastname: lastname,
        email: email
      });
    }
  }, labels.invite))));
};

CreateUserDialog.propTypes = {
  labels: _propTypes["default"].object.isRequired
};
CreateUserDialog.defaultProps = {};
var _default = CreateUserDialog;
exports["default"] = _default;